var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodataQnalistBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 264,
    viewBox: "0 0 358 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 42,
    width: 240,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 66,
    width: 74,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 240,
    height: 24,
    rx: 2,
    fill: "#EEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    width: 72,
    height: 72,
    rx: 2,
    fill: "#EEE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 148,
    width: 240,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 172,
    width: 74,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 112,
    width: 240,
    height: 24,
    rx: 2,
    fill: "#EEE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 106,
    width: 72,
    height: 72,
    rx: 2,
    fill: "#EEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wj04pngcca)",
    d: "M-16-16h390v303H-16z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wj04pngcca",
    x1: 179,
    y1: -122.739,
    x2: 179,
    y2: 211.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataQnalistBg);
export default __webpack_public_path__ + "static/media/nodata_qnalist_bg.5f341dda35a6c3a0cf5e69cc2945e2b7.svg";
export { ForwardRef as ReactComponent };